import { render, staticRenderFns } from "./BaseFrontOfficeSwitch.vue?vue&type=template&id=5c7769a2&scoped=true"
import script from "./BaseFrontOfficeSwitch.vue?vue&type=script&lang=js"
export * from "./BaseFrontOfficeSwitch.vue?vue&type=script&lang=js"
import style0 from "./BaseFrontOfficeSwitch.vue?vue&type=style&index=0&id=5c7769a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c7769a2",
  null
  
)

export default component.exports